import { render, staticRenderFns } from "./FeaturedLargeCards.vue?vue&type=template&id=3475c73a&scoped=true&"
import script from "./FeaturedLargeCards.vue?vue&type=script&lang=js&"
export * from "./FeaturedLargeCards.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedLargeCards.vue?vue&type=style&index=0&id=3475c73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3475c73a",
  null
  
)

export default component.exports